export const common = {
    "videoEmbeder": {
        "consentRequired": "Um dieses YouTube-Video anzusehen, akzeptieren Sie bitte Cookies.",
        "acceptButton": "YouTube-Cookies akzeptieren",
        "noVideo": "Kein Video verfügbar."
    },
    "pricing": {
        "title": "Wähle deinen Plan",
        "subTitle": "Flexible Tarife für jedes Team",
        "monthly": "Monatlich",
        "yearly": "Jährlich",
        "customPrice": "Individuelles Angebot"
    },
    "personal": {
        "title": "Persönliche Nutzung",
        "description": "E-Mail-Sicherheitstools für eine Domain",
        "tooltip": "Ideal für Einzelpersonen mit einer Domain.",
        "cta": "Jetzt starten"
    },
    "smb": {
        "title": "KMU-Paket",
        "description": "Erweiterte Tools für wachsende Unternehmen",
        "tooltip": "Bis zu 5 Domains und 100 DMARC-Berichte pro Monat",
        "cta": "Plan wählen"
    },
    "enterprise": {
        "title": "Enterprise",
        "description": "Individuelle Lösung für große Organisationen",
        "tooltip": "Unbegrenzte Domains, Benutzer und vollständiger SLA-Support.",
        "cta": "Kontakt aufnehmen",
        "badge": "Top-Wahl",
        customPrice: "Maßgeschneidertes Angebot"
    },
    "setupService": {
        "title": "Hilfe bei der Einrichtung von DMARC, SPF und DKIM?",
        "description": "Buche ein einmaliges Einrichtungsgespräch mit unseren Experten.",
        "cta": "Einrichtung Benötigt?"
    },
    termsAndConditions: {
        agree: "Ich stimme der <a>Datenschutzerklärung</a> zu"
    },
    "registerModal": {
        "title": "Starte dein Abo",
        "subtitle": "Sicherer Checkout im nächsten Schritt",
        "emailLabel": "E-Mail-Adresse",
        "note": "Nachdem du deine E-Mail eingetragen hast, wirst du zu unserem sicheren Zahlungsdienstleister",
        "ctaNote": "weitergeleitet, um dein Abo abzuschließen. Ein Konto ist noch nicht erforderlich.",
        "cancel": "Abbrechen",
        "submit": "Weiter zur Zahlung",
        "errors": {
            "exists": "Diese E-Mail ist bereits registriert. Bitte logge dich stattdessen ein.",
            "invalid": "Bitte gib eine gültige E-Mail-Adresse ein.",
            "generic": "Etwas ist schiefgelaufen. Bitte versuche es später erneut."
        },
        "loginLink": "Zum Login →"
    }
};
